import { hmApi } from 'store/api'
import { create, getTemplate, upsertTemplate } from './endpoints'

export const endpoints = hmApi.injectEndpoints({
	endpoints: builder => ({
		sendPushNotification: create(builder),
		getNotificationTemplate: getTemplate(builder),
		upsertTemplate: upsertTemplate(builder),
	}),
})

export const {
	useSendPushNotificationMutation,
	useGetNotificationTemplateQuery,
	useUpsertTemplateMutation,
} = endpoints
